import * as yup from 'yup';
import { isInternational } from './billing-details.utils';
import { convertYupErrorToMessagesObject } from '../../../shared/utils/validation.utils';
import { BILLING_DETAILS_ERROR_MESSAGES } from './billing-details.constants';

const cepRegex = /[0-9]{5}-[0-9]{3}/;
const cnpjRegex = /[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}-[0-9]{2}/;
const taxNumberRegex = /[0-9]{3}-[0-9]{2}-[0-9]{4}/;

const nationalDetails = {
    cep: yup
        .string()
        .nullable(BILLING_DETAILS_ERROR_MESSAGES.INVALID_CEP)
        .test('cep', BILLING_DETAILS_ERROR_MESSAGES.INVALID_CEP, cep => cepRegex.test(cep))
        .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_CEP),
    cnpj: yup
        .string()
        .nullable(BILLING_DETAILS_ERROR_MESSAGES.INVALID_CNPJ)
        .test('cnpj', BILLING_DETAILS_ERROR_MESSAGES.INVALID_CNPJ, cnpj => cnpjRegex.test(cnpj))
        .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_CNPJ),
};

const internationalDetails = {
    zipCode: yup
        .string()
        .nullable(BILLING_DETAILS_ERROR_MESSAGES.INVALID_ZIP_CODE)
        .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_ZIP_CODE),
    taxNumber: yup
        .string()
        .nullable(BILLING_DETAILS_ERROR_MESSAGES.INVALID_TAX_NUMBER)
        .test('taxNumber', BILLING_DETAILS_ERROR_MESSAGES.INVALID_TAX_NUMBER, taxNumber => taxNumberRegex.test(taxNumber))
        .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_TAX_NUMBER),
};

const getFieldsByCountryCode = countryCode => (
    isInternational(countryCode) ? internationalDetails : nationalDetails
);

const billingDetailsSchema = countryCode => yup.object()
    .shape({
        street: yup
            .string()
            .max(128, BILLING_DETAILS_ERROR_MESSAGES.INVALID_STREET_SIZE)
            .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_STREET),
        number: yup
            .string()
            .max(50, BILLING_DETAILS_ERROR_MESSAGES.INVALID_NUMBER_SIZE)
            .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_NUMBER),
        city: yup
            .string()
            .max(128, BILLING_DETAILS_ERROR_MESSAGES.INVALID_CITY_SIZE)
            .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_CITY),
        countryCode: yup
            .string()
            .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_COUNTRY),
        district: yup
            .string()
            .max(50, BILLING_DETAILS_ERROR_MESSAGES.INVALID_DISTRICT_SIZE)
            .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_DISTRICT),
        email: yup
            .string()
            .email(BILLING_DETAILS_ERROR_MESSAGES.INVALID_EMAIL)
            .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_EMAIL),
        phoneNumber: yup
            .string()
            .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_PHONE_NUMBER),
        state: yup
            .string()
            .required(BILLING_DETAILS_ERROR_MESSAGES.REQUIRED_STATE),
        ...getFieldsByCountryCode(countryCode),
    });


export const validateBillingDetails = async (data) => {
    const { countryCode } = data;

    return billingDetailsSchema(countryCode).validate(data, { abortEarly: false }).catch(
        error => Promise.reject(convertYupErrorToMessagesObject(error)),
    );
};
